// src/components/CreateWorkEventModal.js
import axios from "axios";

function CreateWorkEventModal({
  isOpen,
  onClose,
  newWorkEvent,
  setNewWorkEvent,
  currentUser,
  auth,
  API_BASE_URL,
  employees,
  fetchAllEvents,
  setToast,
}) {
  if (!isOpen) return null;

  const handleCreateWorkEvent = async () => {
    if (!currentUser) return;

    const missingFields = [];
    if (!newWorkEvent.description?.trim()) missingFields.push("Event Description");
    if (!newWorkEvent.date_and_time) missingFields.push("Date & Time");
    if (!newWorkEvent.primary_technician) missingFields.push("Primary Technician");
    if (!newWorkEvent.property?.trim()) missingFields.push("Property");
    if (!newWorkEvent.street_address?.trim()) missingFields.push("Street Address");
    if (!newWorkEvent.city?.trim()) missingFields.push("City");
    if (!newWorkEvent.state?.trim()) missingFields.push("State");
    if (!newWorkEvent.zipcode?.trim()) missingFields.push("Zipcode");

    if (missingFields.length > 0) {
      setToast({
        message: `⚠️ Please fill out the following required field(s): ${missingFields.join(", ")}`,
        type: "error",
      });
      return;
    }

    try {
      const token = await auth.currentUser.getIdToken(true);

      const res = await axios.post(
        `${API_BASE_URL}/api/work/create/`,
        { ...newWorkEvent },
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, withCredentials: true }
      );

      console.log("Create Response:", res.data);
      setToast({ message: "✅ Work Event created", type: "success" });
      onClose();

      setNewWorkEvent({
        event_type: "work",
        description: "",
        job_number: "",
        date_and_time: "",
        primary_technician: "",
        additional_technicians: "",
        property: "",
        street_address: "",
        city: "",
        state: "",
        zipcode: "",
      });

      fetchAllEvents();
    } catch (err) {
      console.error("Create Work Event failed:", err);
      setToast({
        message: `⚠️ Create failed: ${err.response?.data?.error || err.message || "Unknown error"}`,
        type: "error",
      });
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-xl shadow-xl max-w-md w-full font-sans">
        <h3 className="text-xl font-bold mb-4 text-orange-700">Create Work Event</h3>

        <div className="space-y-3">
          <input
            type="text"
            placeholder="Event Description"
            value={newWorkEvent.description}
            onChange={(e) => setNewWorkEvent({ ...newWorkEvent, description: e.target.value })}
            className="w-full border px-3 py-2 rounded"
          />
          <input
            type="datetime-local"
            value={newWorkEvent.date_and_time}
            onChange={(e) => setNewWorkEvent({ ...newWorkEvent, date_and_time: e.target.value })}
            className="w-full border px-3 py-2 rounded"
          />

          {/* Primary Technician */}
          <select
            className="w-full border px-3 py-2 rounded bg-white"
            value={newWorkEvent.primary_technician || ""}
            onChange={(e) => setNewWorkEvent({ ...newWorkEvent, primary_technician: e.target.value })}
          >
            <option value="" disabled>Primary Technician</option>
            {employees.slice().sort((a, b) => a.name.localeCompare(b.name)).map(emp => (
              <option key={emp.id} value={emp.name}>{emp.name}</option>
            ))}
          </select>

          {/* Additional Technicians */}
          <p className="text-base text-black">Additional Technicians:</p>
          <p className="text-sm text-gray-500 mb-1">Hold Ctrl (Windows) or Cmd (Mac) to select multiple technicians</p>
          <select
            multiple
            className="border p-2 w-full mb-2 h-40"
            value={newWorkEvent.additional_technicians ? newWorkEvent.additional_technicians.split(",").map(t => t.trim()) : []}
            onChange={(e) => {
              const selected = Array.from(e.target.selectedOptions, opt => opt.value);
              setNewWorkEvent({ ...newWorkEvent, additional_technicians: selected.join(", ") });
            }}
          >
            {employees.slice().sort((a, b) => a.name.localeCompare(b.name)).map(emp => (
              <option key={emp.id} value={emp.name}>{emp.name}</option>
            ))}
          </select>

          <input placeholder="Property" value={newWorkEvent.property} onChange={(e) => setNewWorkEvent({ ...newWorkEvent, property: e.target.value })} className="w-full border px-3 py-2 rounded" />
          <input placeholder="Street Address" value={newWorkEvent.street_address} onChange={(e) => setNewWorkEvent({ ...newWorkEvent, street_address: e.target.value })} className="w-full border px-3 py-2 rounded" />
          <input placeholder="City" value={newWorkEvent.city} onChange={(e) => setNewWorkEvent({ ...newWorkEvent, city: e.target.value })} className="w-full border px-3 py-2 rounded" />
          <input placeholder="State" value={newWorkEvent.state} onChange={(e) => setNewWorkEvent({ ...newWorkEvent, state: e.target.value })} className="w-full border px-3 py-2 rounded" />
          <input placeholder="Zipcode" value={newWorkEvent.zipcode} onChange={(e) => setNewWorkEvent({ ...newWorkEvent, zipcode: e.target.value })} className="w-full border px-3 py-2 rounded" />
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">Cancel</button>
          <button onClick={handleCreateWorkEvent} className="px-4 py-2 bg-orange-600 text-white rounded hover:bg-orange-700">Create</button>
        </div>
      </div>
    </div>
  );
}

export default CreateWorkEventModal;
